<div class="d-flex justify-content-between" *ngIf="currentCourse">
    <div>
        <span class="detail-name">{{currentCourse.CourseShortDescription}} time spent</span>
        {{ displayTimeWithoutSeconds(currentCourse.TimeSpent) }}
    </div>
    <div>
        <span class="ml-4 detail-name">Books read</span>
        {{ currentCourse.BooksRead }}
    </div>
    <div>
        <span class="ml-4 detail-name">Songs sung</span>
        {{ currentCourse.SongsSung }}
    </div>
    <div>
        <span class="ml-4 detail-name">Speaking Opportunities</span>
        {{ currentCourse.SpeechRecAttempts }}
    </div>
    <div *ngIf="currentCourse && currentCourse.LastStartedActivity">
        <span class="ml-4 detail-name">Most Recent Activity</span>
        {{ longDateFormat(currentCourse.LastStartedActivity) }}
    </div>
    <div *ngIf="!(currentCourse && currentCourse.LastStartedActivity)">
        <span class="ml-4 detail-name">Most Recent Activity</span>
        No Activity
    </div>
</div>
<hr class="major-divider">
<h2 class="mb-0 grey-background legend-header justify-content-between">
    <div>Units</div>
    <div class="legend">
        <div class="unit-circle completed legend-circle"></div>
        <div class="legend-label">Completed</div>
        <div class="unit-circle in-progress legend-circle"></div>
        <div class="legend-label">Current</div>
    </div>
</h2>
<div class="m-4">
    <div *ngFor="let unit of currentCourse.Units" (click)="selectUnit(unit)" class="mr-2 mb-2"
        [ngClass]="getUnitCircleClasses(unit)">
        {{ unit.UnitNumber }}
    </div>
</div>
<hr class="major-divider">
<app-unit-report [studentID]="studentId" [courseCode]="currentCourse.CourseCode" [unitNumber]="selectedUnitNumber">
</app-unit-report>